interface AssignConfirmationMessageProps {
  /** The level just assigned to the current hand (null only as a defensive fallback). */
  level: number | null;
}

// Content of the post-Assign auto-advance MASK overlay that covers the gray content container
// on the Overcalling — Assign Level of Difficulty page (Session 2026-05-29). It shows the
// assigned level in large text plus a "Moving to next hand ..." line so it is unmistakable to
// the editor what happened and that the page is about to advance. Colors are tuned for the
// light mask background (client sign-off 2026-05-29).
// Introduced by feature 012-overcalling-assign-difficulty.
export function AssignConfirmationMessage({ level }: AssignConfirmationMessageProps) {
  return (
    <div className="text-center px-4">
      <div className="text-2xl short:text-xl font-bold text-green-700">
        {level != null
          ? `Level of difficulty ${level} assigned.`
          : "'Level of difficulty' assigned."}
      </div>
      <div className="mt-2 short:mt-1 text-lg short:text-base font-medium text-ink">
        Moving to next hand ...
      </div>
    </div>
  );
}
